import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import { Container, Typography } from '@mui/material';
import Login from './components/Login';
import PrivateRoute from './components/PrivateRoute';
import DashboardLayout from './components/DashboardLayout';
import Dashboard from './components/Dashboard';
import Wallboard from './components/Wallboard';
import TrafficAnalysis from './components/TrafficAnalysis';
import AudioQuality from './components/AudioQuality';
import MediaServersPage from './pages/MediaServersPage';
import RoutingQualityPage from './pages/RoutingQualityPage';
import AgentBehaviourPage from './pages/AgentBehaviourPage';
import CallDetailPage from './pages/CallDetailPage';
import CDRPage from './pages/CDRPage';
import SearchPage from './pages/SearchPage';
import AjaxFailuresPage from './pages/AjaxFailuresPage';
import { authAPI } from './services/api';

const theme = createTheme({
  palette: {
    mode: 'dark',
    primary: {
      main: '#2196f3',
    },
    secondary: {
      main: '#f50057',
    },
  },
});

// Placeholder component for routes not yet implemented
function ComingSoon({ title }) {
  return (
    <Container maxWidth="lg" sx={{ mt: 4 }}>
      <Typography variant="h4" gutterBottom>
        {title}
      </Typography>
      <Typography variant="body1" color="text.secondary">
        This feature is coming soon! The backend API is ready.
      </Typography>
    </Container>
  );
}

function App() {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <Router>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route
            path="/call-detail/:callId"
            element={
              <PrivateRoute>
                <CallDetailPage />
              </PrivateRoute>
            }
          />
          <Route
            path="/cdr/:callId"
            element={
              <PrivateRoute>
                <CDRPage />
              </PrivateRoute>
            }
          />
          <Route
            path="/dashboard"
            element={
              <PrivateRoute>
                <DashboardLayout />
              </PrivateRoute>
            }
          >
            <Route index element={<Dashboard />} />
            <Route path="wallboard" element={<Wallboard />} />
            <Route path="traffic" element={<TrafficAnalysis />} />
            <Route path="audio-quality" element={<AudioQuality />} />
            <Route path="media-servers" element={<MediaServersPage />} />
            <Route path="routing-quality" element={<RoutingQualityPage />} />
            <Route path="agent-behaviour" element={<AgentBehaviourPage />} />
            <Route path="failures" element={<ComingSoon title="Failures" />} />
            <Route path="ajax-failures" element={<AjaxFailuresPage />} />
            <Route path="search" element={<SearchPage />} />
          </Route>
          <Route
            path="/"
            element={
              authAPI.isAuthenticated() ? (
                <Navigate to="/dashboard" replace />
              ) : (
                <Navigate to="/login" replace />
              )
            }
          />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </Router>
    </ThemeProvider>
  );
}

export default App;
